<template>
  <div>
    <p>
      We want to provide you with the most relevant project opportunities and latest updates. To do this well, we would like to ask for permission to send you updates and notifications.
    </p>
    <p>
      You can opt-out of notifications and updates at any time from your profile settings.
    </p>
    <p>
      For more information on how we use your data, see our Privacy Policy.
      <a
        target="_blank"
        href="https://riverflex.com/privacy-policy-2/"
      >
        Privacy Policy
      </a>.
    </p>
    <div class="gdpr-agreement">
      <v-checkbox
        v-model="isSubscribedToEmail"
        label="Yes! Send me job opportunities and updates from Riverflex."
      />
      <div class="text-center">
        <v-btn
          rounded
          color="primary"
          dark
          @click="handleAcceptAgreementClick"
        >
          {{ okBtnTitle }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { trackGDPRAcceptTap } from '@/segmentAnalytics/gdpr'
import { trackEmailNotificationTap } from '@/segmentAnalytics/profile'

@Component({})
export default class GDPRAgreement extends Vue {
  @Prop({ default: 'OK!' }) okBtnTitle: string;

  isSubscribedToEmail: boolean = false

  handleAcceptAgreementClick () {
    this.$store.dispatch('updateProfile', { gdprAccepted: true, email_subscribe: this.isSubscribedToEmail })
    trackGDPRAcceptTap()
    this.$emit('acceptAgreement')
  }
}
</script>
